<template>
<div>
  <div class="menu">
      <a class="open_menu" href="javascript:;"><img src="../assets/img/menu.svg"/></a>
      <a class="close_menu" href="javascript:;"><img src="../assets/img/close.svg"/></a>
    </div>
    <Index/>
    <div id="inst">
    <Instagram />
    </div>
    <Contacts />
    <Menu />
   


</div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import axios from 'axios'
import Menu from '@/components/Menu.vue'
import Instagram from '@/components/Instagram.vue'
import Contacts from '@/components/Contacts.vue'
import Index from '@/components/Home.vue'

export default {
  name: 'home',
  components: {
    Menu, Instagram, Contacts, Index
  },
  mounted () {
    
      $("div.menu a").click(function() {
        $(".sidebar").toggleClass("open-sidebar");
        $("div.menu").toggleClass("open");
      });
  }
}
</script>
